import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { shippingInfoStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

shippingInfoStyles.shippingInfoAccordionSection = {
    mergeCss: false,
    titleTypographyProps: {
        variant: "h4",
        css: css`
            margin-bottom: 0;
            color: ${COLORS.text.main};
            font-family: ${TYPOGRAPHY.h4.fontFamily};
            font-size: ${TYPOGRAPHY.h4.size}px;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: ${TYPOGRAPHY.h4.lineHeight};
            font-style: ${TYPOGRAPHY.h4.fontStyle};
        `,
    },
    toggleIconProps: {
        src: "ChevronDown",
        css: css`
            color: ${COLORS.text.main};
        `,
    },
    expandIconProps: {
        src: undefined,
    },
    collapseIconProps: {
        src: undefined,
    },
    headerProps: {
        css: css`
            background: transparent;
            button {
                background-color: #F5F5F5 !important;
                padding: 10px 20px !important;
                border-radius: 8px !important;
                border: none !important;
                &:focus {
                    background-color: #F5F5F5 !important;
                    padding: 10px 20px !important;
                    border: none !important;
                }
            }
        `,
    },
    panelProps: {
        css: css`
            padding-top: 0;
            border: none;
        `,
    },
};

shippingInfoStyles.accordion = {
    css: css`
        margin-bottom: 0;
        > dd {
            > div[class^="GridWrapper"] {
                > div[class^="GridOffset"] {
                    width: 100% !important;
                }
            }
        }
    `,
};
